import css from "./CheckBox.module.css";

const CheckBox = ({ children, onChange }) => {
  if (!children) return null;

  const { label, name, value, required } = children;

  const handleChange = (e) => {
    const checked = e.target.checked;
    // notify FormRow/Form
    onChange?.({ target: { name, value: checked } });
  };

  return (
    <label className={css.CheckBox}>
      <input
        type="checkbox"
        name={name}
        checked={!!value}
        onChange={handleChange}
      />
      <span className={css.LabelText}>
        {label}
        {required && <span className={css.Required}>*</span>}
      </span>
    </label>
  );
};

export default CheckBox;
